import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import ThreeDot from "../common/ThreeDot";
import { getAllOrders } from "../../services/order.service";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import ViewDetailsButton from "../common/ViewDetailsButton";
import { getDashbordData } from "../../services/auth.service";

export default function Dashboard() {
  const { token } = useSelector((state) => state?.auth);
  const [orders, setOrders] = useState(null);
  const [dashboard, setDashboard] = useState(null);

  const handleDown = () => {
    window.scrollTo(5, 5);
  };

  const fetchOrders = async (page = 1) => {
    try {
      const params = { page, page_size: 5, retailer_order_list: "True" };
      const res = await getAllOrders(token, params);
      if (res && res.status >= 200 && res.status < 300) {
        setOrders(res?.data?.results?.orders);
        // console.log(res?.data);
      } else {
        Swal.fire(
          "Error",
          res?.data?.message || "Failed to fetch orders. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  const fetchDashboardData = async (page = 1) => {
    try {
      const res = await getDashbordData(token);
      if (res && res.status >= 200 && res.status < 300) {
        setDashboard(res?.data);
        // console.log(res?.data);
      } else {
        Swal.fire(
          "Error",
          res?.data?.message || "Failed to fetch orders. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    fetchOrders();
    fetchDashboardData();
  }, []);

  return (
    <div className="content-body">
      {/* Work in progress */}
      {/* <div className="container-fluid">
        <div className="row">
        <div className="col-xl-12 col-xxl-12 col-lg-12 col-sm-12">
        <div className="card py-5">
          <div className="card-body py-5 my-5">
            <div className="text-center py-5 my-5 fs-1">
            Work in progress
            </div>
          </div>
          </div></div>
        </div>
      </div> */}
      {/* ebd */}
      {/* <!-- row --> */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-3 col-lg-3 col-sm-6">
            <Link to="/orders">
              <div className="card overflow-hidden">
                <div className="card-header media border-0 pb-0 mb-4">
                  <div className="media-body">
                    <h2 className="text-black">
                      {dashboard?.orders}
                      {/* <span className="text-success fs-14">+2.7%</span> */}
                    </h2>
                    <p className="mb-0 text-black">Orders</p>
                  </div>
                  <img src="/assets/images/iconly/orders.png" />
                </div>
              </div>
            </Link>
          </div>
          <div className="col-xl-3 col-lg-3 col-sm-6">
            <Link to="/brands">
              <div className="card overflow-hidden">
                <div className="card-header media border-0 pb-0 mb-4">
                  <div className="media-body">
                    <h2 className="text-black">
                      {dashboard?.brands}
                      {/* <span className="text-danger fs-14">-3.7%</span> */}
                    </h2>
                    <p className="mb-0 text-black">Brands</p>
                  </div>
                  <img src="/assets/images/iconly/brands.png" />
                </div>
              </div>
            </Link>
          </div>
          <div className="col-xl-3 col-lg-3 col-sm-6" onClick={handleDown}>
            <Link to="/agent">
              <div className="card overflow-hidden">
                <div className="card-header media border-0 pb-0 mb-4">
                  <div className="media-body">
                    <h2 className="text-black">
                      {dashboard?.agent}
                      {/* <span className="text-danger fs-14">-3%</span> */}
                    </h2>
                    <p className="mb-0 text-black">Agents</p>
                  </div>
                  <img src="/assets/images/iconly/customers.png" />
                </div>
              </div>
            </Link>
          </div>
          <div className="col-xl-3 col-lg-3 col-sm-6">
            <Link to="/retailer">
              <div className="card overflow-hidden">
                <div className="card-header media border-0 pb-0 mb-4">
                  <div className="media-body">
                    <h2 className="text-black">
                      {dashboard?.retailers}
                      {/* <span className="text-danger fs-14">-3%</span> */}
                    </h2>
                    <p className="mb-0 text-black">Retailers</p>
                  </div>
                  <img src="/assets/images/iconly/retailer.png" />
                </div>
              </div>
            </Link>
          </div>

          <div className="col-xl-12 col-xxl-12 col-lg-12 col-sm-12">
            {orders?.length > 0 ? (
              <div className="card">
                <div className="card-header border-0">
                  <div>
                    <h4 className="card-title mb-2">Recent Orders</h4>
                    {/* <p className="fs-13 mb-0">
                    Lorem ipsum dolor Lorem ipsum dolor
                  </p> */}
                  </div>

                  {/* <select
                  className="default-select style-1"
                  aria-label="Default select example"
                >
                  <option selected>Newest</option>
                  <option value="1">Latest</option>
                  <option value="2">Old</option>
                </select> */}
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive ">
                    <table className="table order-request2">
                      <tbody>
                        {orders &&
                          orders?.length > 0 &&
                          orders?.map((item, i) => (
                            <tr key={i}>
                              <td>
                                <div className="media media3 align-items-center">
                                  {/* <img
                                  className="me-3 rounded-circle"
                                  width="50px"
                                  src="/assets/images/kidskart/order/o11.png"
                                  alt="DexignZone"
                                /> */}
                                  <div className="media-body ms-2">
                                    <p className="mb-0 text-primary">
                                      #{item.order_id}
                                    </p>
                                    <h5 className="m-0 py-2">
                                      <Link
                                        className="text-black"
                                        to="ecom-product-detail.html"
                                      >
                                        {item.retailer}
                                      </Link>
                                    </h5>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <h6>
                                  {new Date(item?.created_at)
                                    .toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    })
                                    .replace(/(\b[A-Za-z]{3}\b)/, "$1,")}
                                </h6>
                                <p className="mb-0">{item.delivery_address}</p>
                              </td>
                              <td style={{ width: "100px" }}>
                                <div className="d-flex align-items-center justify-content-center">
                                  <h4 className="mb-0 me-3 fs-16 text-black d-inline-block">
                                    ₹
                                    {(item.final_amount * 1)?.toLocaleString(
                                      "en-IN",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    )}
                                  </h4>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <Link
                                    className={`btn ${
                                      item?.status === "SHIPPED"
                                        ? "btn-secondary"
                                        : item?.status === "CANCELLED"
                                        ? "btn-danger"
                                        : item?.status === "PENDING"
                                        ? "btn-warning"
                                        : item?.status === "DELIVERED"
                                        ? "btn-success"
                                        : "btn-info"
                                    } light btn-sm`}
                                  >
                                    {item.status}
                                  </Link>
                                  <div className="dropdown ms-auto c-pointer">
                                    <ThreeDot />
                                    <div className="dropdown-menu dropdown-menu-end">
                                      <ViewDetailsButton
                                        to={`/orders/details`}
                                        id={item.order_id}
                                        tab={"details"}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    <div className="card-footer border-0 pt-0 text-center">
                      <Link to="/orders" className="btn-link">
                        View More &gt;&gt;
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="card">
                <div className="card-body">
                  <div className="py-5 my-5 text-center fs-4 fw-bold">
                    No Orders
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
